import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center gap-3" }
const _hoisted_3 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_4 = { class: "bg-white rounded-xl border border-gray-200 p-6 mb-6" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4" }
const _hoisted_6 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "ml-2 text-xs text-gray-400" }
const _hoisted_10 = { class: "flex flex-wrap gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mt-5 flex justify-end" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "bg-white rounded-xl border border-gray-200 p-6 mb-6" }
const _hoisted_15 = { class: "mt-4 flex flex-wrap gap-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "text-sm text-gray-400 self-center"
}
const _hoisted_19 = { class: "bg-white rounded-xl border border-gray-200 overflow-hidden" }
const _hoisted_20 = { class: "overflow-x-auto" }
const _hoisted_21 = { class: "min-w-full text-sm" }
const _hoisted_22 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_23 = { class: "px-4 py-2" }
const _hoisted_24 = { class: "px-4 py-2" }
const _hoisted_25 = { class: "px-4 py-2 text-gray-500" }
const _hoisted_26 = { class: "px-4 py-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "text-gray-300"
}
const _hoisted_29 = { key: 0 }

import { ref, onMounted } from 'vue'
import { FileBarChart, Download, Send } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import StatsFilterBar from '@/components/dashboard/StatsFilterBar.vue'
import { apiFetch, API_BASE_URL } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'


export default /*@__PURE__*/_defineComponent({
  __name: 'RapportJournalierView',
  setup(__props) {

const toast = useToast()
const dayLabels = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim']

const config = ref<any>({ enabled: false, send_time: '09:00', timezone: 'Africa/Porto-Novo', weekdays: [0, 1, 2, 3, 4] })
const recipientsText = ref('')
const saving = ref(false)
const busy = ref(false)
const filters = ref<Record<string, string>>({})
const runs = ref<any[]>([])

function toggleDay(i: number) {
  const idx = config.value.weekdays.indexOf(i)
  if (idx === -1) config.value.weekdays.push(i)
  else config.value.weekdays.splice(idx, 1)
}

function statusLabel(s: string) {
  return s === 'sent' ? 'Envoyé' : s === 'error' ? 'Erreur' : 'Généré'
}
function formatDate(s: string) {
  try { return new Date(s).toLocaleString('fr-FR') } catch { return s }
}

async function loadConfig() {
  try {
    const c = await apiFetch('/api/admin/reports/config/')
    config.value = { ...c }
    recipientsText.value = (c.recipients || []).join('\n')
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Configuration introuvable')
  }
}

async function saveConfig() {
  saving.value = true
  try {
    const recipients = recipientsText.value.split('\n').map(s => s.trim()).filter(Boolean)
    const c = await apiFetch('/api/admin/reports/config/', {
      method: 'PUT',
      body: JSON.stringify({
        recipients,
        enabled: config.value.enabled,
        send_time: config.value.send_time,
        timezone: config.value.timezone,
        weekdays: config.value.weekdays,
      }),
    })
    config.value = { ...c }
    recipientsText.value = (c.recipients || []).join('\n')
    toast.success('Enregistré', 'Configuration mise à jour.')
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Enregistrement impossible')
  } finally {
    saving.value = false
  }
}

function onFilterChange(params: Record<string, string>) {
  filters.value = params || {}
}

async function blobDownload(endpoint: string, method = 'POST', body?: any) {
  const resp = await fetch(`${API_BASE_URL}${endpoint}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  })
  if (!resp.ok) {
    let msg = `Erreur ${resp.status}`
    try { msg = (await resp.json()).error || msg } catch { /* ignore */ }
    throw new Error(msg)
  }
  const blob = await resp.blob()
  const cd = resp.headers.get('content-disposition') || ''
  const match = cd.match(/filename="?([^"]+)"?/)
  const filename = match ? match[1] : 'rapport.pptx'
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

async function downloadReport() {
  busy.value = true
  try {
    await blobDownload('/api/admin/reports/generate/', 'POST', filters.value)
    toast.success('Rapport généré', 'Le téléchargement va démarrer.')
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Génération impossible')
  } finally {
    busy.value = false
  }
}

async function sendReport() {
  busy.value = true
  try {
    const res: any = await apiFetch('/api/admin/reports/send/', {
      method: 'POST',
      body: JSON.stringify(filters.value),
    })
    if (res.errors && res.errors.length && !res.sent.length) {
      toast.error('Échec', res.errors.join(', '))
    } else {
      toast.success('Envoyé', `Rapport envoyé à ${res.sent.length} destinataire(s).`)
    }
    loadRuns()
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Envoi impossible')
  } finally {
    busy.value = false
  }
}

async function downloadRun(r: any) {
  try {
    await blobDownload(`/api/admin/reports/runs/${r.id}/download/`, 'GET')
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Téléchargement impossible')
  }
}

async function loadRuns() {
  try {
    const res: any = await apiFetch('/api/admin/reports/runs/')
    runs.value = res.results || []
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Historique indisponible')
  }
}

onMounted(() => { loadConfig(); loadRuns() })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(FileBarChart), { class: "w-7 h-7 text-[#22282F]" })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900" }, "Rapport journalier"),
            _createElementVNode("p", { class: "text-sm text-gray-500" }, "Configuration de l'envoi automatique et génération à la demande.")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "font-semibold text-gray-800" }, "Envoi automatique", -1)),
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((config.value.enabled) = $event)),
                class: "w-4 h-4"
              }, null, 512), [
                [_vModelCheckbox, config.value.enabled]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm text-gray-600" }, "Activé (jours ouvrés)", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-1" }, "Destinataires (un email par ligne)", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((recipientsText).value = $event)),
                rows: "5",
                class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono",
                placeholder: "nom@gouv.bj"
              }, null, 512), [
                [_vModelText, recipientsText.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-1" }, "Heure d'envoi", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((config.value.send_time) = $event)),
                  class: "px-3 py-2 border border-gray-300 rounded-lg text-sm"
                }, null, 512), [
                  [_vModelText, config.value.send_time]
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(config.value.timezone), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-2" }, "Jours d'envoi", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dayLabels, (d, i) => {
                    return _createElementVNode("button", {
                      key: i,
                      type: "button",
                      onClick: ($event: any) => (toggleDay(i)),
                      class: _normalizeClass(['px-3 py-1.5 rounded-lg text-sm border',
                    config.value.weekdays.includes(i)
                      ? 'bg-[#1d2a5e] text-white border-[#1d2a5e]'
                      : 'bg-white text-gray-500 border-gray-300'])
                    }, _toDisplayString(d), 11, _hoisted_11)
                  }), 64))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: saveConfig,
              disabled: saving.value,
              class: "px-5 py-2 bg-[#1d2a5e] text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-50"
            }, _toDisplayString(saving.value ? 'Enregistrement…' : 'Enregistrer'), 9, _hoisted_13)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "font-semibold text-gray-800 mb-1" }, "Génération manuelle", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-4" }, "Appliquez des filtres puis téléchargez ou envoyez le rapport.", -1)),
          _createVNode(StatsFilterBar, { onChange: onFilterChange }),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              onClick: downloadReport,
              disabled: busy.value,
              class: "px-4 py-2 bg-[#1d2a5e] text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-50 flex items-center gap-2"
            }, [
              _createVNode(_unref(Download), { class: "w-4 h-4" }),
              _cache[9] || (_cache[9] = _createTextVNode(" Télécharger (.pptx) "))
            ], 8, _hoisted_16),
            _createElementVNode("button", {
              onClick: sendReport,
              disabled: busy.value,
              class: "px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-50 flex items-center gap-2"
            }, [
              _createVNode(_unref(Send), { class: "w-4 h-4" }),
              _cache[10] || (_cache[10] = _createTextVNode(" Envoyer maintenant "))
            ], 8, _hoisted_17),
            (busy.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Traitement…"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", { class: "px-5 py-4 border-b border-gray-100 flex items-center justify-between" }, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "font-semibold text-gray-800" }, "Historique des générations", -1)),
            _createElementVNode("button", {
              onClick: loadRuns,
              class: "text-sm text-[#1d2a5e] hover:underline"
            }, "Actualiser")
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "bg-gray-50 text-gray-500" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Date"),
                  _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Type"),
                  _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Statut"),
                  _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Destinataires"),
                  _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Fichier")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runs.value, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.id,
                    class: "border-t border-gray-100"
                  }, [
                    _createElementVNode("td", _hoisted_22, _toDisplayString(formatDate(r.created_at)), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(r.triggered_by === 'auto' ? 'Automatique' : 'Manuelle'), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['px-2 py-0.5 rounded-full text-xs',
                    r.status === 'sent' ? 'bg-emerald-100 text-emerald-700'
                    : r.status === 'error' ? 'bg-red-100 text-red-700'
                    : 'bg-gray-100 text-gray-600'])
                      }, _toDisplayString(statusLabel(r.status)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_25, _toDisplayString((r.recipients_sent || []).length || '—'), 1),
                    _createElementVNode("td", _hoisted_26, [
                      (r.has_file)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _withModifiers(($event: any) => (downloadRun(r)), ["prevent"]),
                            class: "text-[#1d2a5e] hover:underline"
                          }, "Télécharger", 8, _hoisted_27))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                    ])
                  ]))
                }), 128)),
                (!runs.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _cache[14] || (_cache[14] = [
                      _createElementVNode("td", {
                        colspan: "5",
                        class: "px-4 py-6 text-center text-gray-400"
                      }, "Aucune génération pour l'instant.", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})